import React from "react";
import { UnauthenticatedPage } from 'pages/layouts';
import { SuccessPanel } from 'components/notifications';

export function PaymentSuccessPage() {
    return (
        <UnauthenticatedPage>
            <SuccessPanel>
                <p>Thank you for submitting your payment. You may now close this window.</p>
            </SuccessPanel>
        </UnauthenticatedPage>
    );
}
